import { eventActions } from "../../actionTypes";

const initialState = {
	events: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case eventActions.FETCH_EVENTS: {
			return action.payload.reset
				? { ...initialState, fetching: true }
				: { ...state, fetching: true };
		}

		case eventActions.FETCH_EVENTS_FULFILLED: {
			return state.events.current_page < action.payload.current_page
				? {
						...state,
						fetching: false,
						fetched: true,
						events: {
							...action.payload,
							data: state.events.data
								? [...state.events.data, ...action.payload.data]
								: action.payload.data,
						},
				  }
				: {
						...state,
						fetching: false,
						fetched: true,
						events: action.payload,
				  };
		}

		case eventActions.FETCH_EVENTS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
